// importing styles

// importing components
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Col, Row } from "antd";

// importing icons

// importing images
import CheckoutForm from "./CheckoutForm";

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!publishableKey) {
    // Create React App inlines this at build time, so a missing value means the
    // bundle was built without it. Fail loudly here instead of silently
    // rendering a payment form that can never be submitted.
    console.error(
        "REACT_APP_STRIPE_PUBLISHABLE_KEY is not set. Add it to .env.development (test key) or .env.production.local (live key) and rebuild."
    );
}

const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

const PaymentScreen = ({ setStep, stripeData, order }) => {
    const appearance = {
        theme: "stripe",
    };

    if (!stripePromise || !stripeData?.client_secret) {
        return (
            <div className="container">
                <p style={{ textAlign: "center", padding: "40px 0" }}>
                    We couldn't start the payment for this order. Please contact
                    support with your order number
                    {order?.id ? ` (#${order.id})` : ""}.
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="container">
                <Row gutter={[30]}>
                    <Col
                        xs={24}
                        lg={24}
                        style={{ display: "flex", justifyContent: "center" }}
                    >
                        <Elements
                            options={{
                                clientSecret: stripeData.client_secret,
                                appearance: appearance,
                            }}
                            stripe={stripePromise}
                        >
                            <CheckoutForm order={order} />
                        </Elements>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default PaymentScreen;
